import { entityMyApi } from '@/features/Entity_my/api/entityApi';

/** L_CLIENTS.CLIENT_NM — GET /api/entity_my/client-info/:clientCd (세션 CLIENT_CD와 일치 시에만 조회 허용) */
export async function fetchSessionClientNm(clientCd: string): Promise<string> {
  const cd = String(clientCd || '').trim();
  if (!cd) return '';
  const res = await entityMyApi.getClientInfo(cd);
  const data = (res as any)?.data ?? res;
  return String(data?.CLIENT_NM ?? data?.clientNm ?? '').trim();
}
